import React from "react";
import ImageCrop from "./ImageCrop";

const ImageUpload = (props) => {
  return <ImageCrop profileData={props.profileData} savePhotoAsFile={props.savePhotoAsFile} />;
};

export default ImageUpload;
